export const removeNullValues = (obj: any): any => {
  return Object.entries(obj)
    .filter(([_, value]) => value != null)
    .reduce(
      (accumulator, [key, value]) => ({ ...accumulator, [key]: value }),
      {}
    );
};

export const getHttpReferer = (): string | null => {
  if (document.referrer) {
    return document.referrer;
  }
  return null;
};
